<div id="change-log" class="changelog-container">
  <header class="page-header">
    <h1 class="page-title">{{ pageTitle }}</h1>
  </header>

  <main class="release-list">
    @for (release of pagedReleases; track release) {
      <section class="release-card">
        <div class="release-header">
          <h2 class="release-version">v{{ release.version }}</h2>
          <span class="release-date">{{ release.date | date:'mediumDate' }}</span>
        </div>
        <ul class="change-list">
          @for (changeDescription of release.description; track changeDescription) {
            <li>
              <p class="change-description">
                {{ changeDescription }}
              </p>
            </li>
          }
        </ul>
      </section>
    }
  </main>

  <div class="changelog-pagination-controls">
    <select class="form-select" style="width: auto; display: inline-block; margin-right: 10px;"
      [(ngModel)]="pageSize" (ngModelChange)="refreshReleases()">
      <option [ngValue]="5">5 items per page</option>
      <option [ngValue]="10">10 items per page</option>
      <option [ngValue]="20">20 items per page</option>
    </select>
    <ngb-pagination [collectionSize]="collectionSize"
      [(page)]="page"
      [pageSize]="pageSize"
      (pageChange)="refreshReleases()"
      [rotate]="true"
      [ellipses]="false"
      [boundaryLinks]="true"
      [maxSize]="3">
    </ngb-pagination>
  </div>
</div>
